

import Navigation from '@/components/landing/Navigation';
import Footer from '@/components/landing/Footer';
import { Button } from '@/components/ui/button';
import { useBlogPost } from '@/components/blog/hooks/useBlogPost';
import { BlogHeader } from '@/components/blog/BlogHeader';
import { BlogContent } from '@/components/blog/BlogContent';
import { BlogMetaTags } from '@/components/blog/BlogMetaTags';
import { BlogLoadingState } from '@/components/blog/BlogLoadingState';
import { BlogErrorState } from '@/components/blog/BlogErrorState';
import { BlogStyleSheet } from '@/components/blog/BlogStyleSheet';

const BlogPost = () => {
  const {
    post,
    isLoading,
    error,
    isAdmin,
    handleLogin,
    handleSignup,
    handleEditPost,
    navigate
  } = useBlogPost();
  
  if (isLoading) {
    return <BlogLoadingState />;
  }
  
  if (error || !post) {
    return <BlogErrorState onLogin={handleLogin} onSignup={handleSignup} />;
  }
  
  return (
    <div className="bg-white min-h-screen">
      <BlogMetaTags post={post} />
      
      <Navigation onLogin={handleLogin} onSignup={handleSignup} />
      
      <div className="container mx-auto px-4 pt-32 pb-16 md:pt-40 md:pb-28">
        <div className="max-w-4xl mx-auto">
          <BlogHeader 
            post={post} 
            isAdmin={isAdmin} 
            onEdit={handleEditPost} 
          />
          
          <BlogContent post={post} />
          
          <div className="mt-12 flex justify-between">
            <Button variant="outline" onClick={() => navigate('/blog')}>
              Back to Blog
            </Button>
          </div>
        </div>
      </div>
      
      <Footer />
      <BlogStyleSheet />
    </div>
  );
};

export default BlogPost;
